/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Added by Customily
window.addEventListener("customily-save-customization-ready", async (e) => {
  await new Promise((resolve) => setTimeout(resolve, 1500));
  // set loading image
  const source = $(".Cart .Cart__ItemList").get(0);
  const image = source.querySelector(".CartItem .CartItem__Image");
  // only load image withc customily thumb
  if (
    image &&
    !image.getAttribute("obtained") &&
    image.getAttribute("_customily")
  ) {
    image.alt = "Loading...";
    $(image).parent().css({
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    });
    $(image).replaceWith(function () {
      return $(image).prop("alt");
    });
  }
  // end set loading image
  updateCartDrawerImage(source, image);
});

// Added by Customily
function updateCartDrawerImage(src, image, copy = null) {
  try {
    const imageCopy = copy ?? image?.cloneNode(true);
    if (imageCopy) {
      if (!imageCopy.obtained) {
        fetch(imageCopy.src)
          .then((response) => {
            if (response.ok) {
              return response.blob();
            }
            throw new Error("");
          })
          .then((blob) => {
            const container = src.querySelector(
              ".CartItem .CartItem__ImageWrapper .AspectRatio"
            );
            container.textContent = "";
            imageCopy.src = URL.createObjectURL(blob);
            imageCopy.setAttribute("obtained", "true");
            src.setAttribute("obtained", "true");
            container.appendChild(imageCopy);
          })
          .catch((error) => {
            // 'trying to get the preview'
            new Promise((resolve) => setTimeout(resolve, 1500)).then(
              (response) => this.updateCartDrawerImage(src, null, imageCopy)
            );
          });
      }
    }
  } catch (error) {}
}